import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
export function VerifyEmailPage() {
  return <div className="min-h-screen bg-background flex items-center justify-center p-6" data-id="element-5874">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md" data-id="element-5875">
        <div className="flex flex-col items-center mb-8" data-id="element-5876">
          <Link to="/" className="flex items-center gap-2 mb-6" data-id="element-5877">
            <span className="text-2xl font-bold tracking-tight text-textMain" data-id="element-5878">
              Booker
            </span>
            <div className="w-2 h-2 rounded-full bg-primary mt-1" data-id="element-5879"></div>
          </Link>
        </div>

        <div className="bg-surface border border-border rounded-xl p-8 shadow-xl text-center" data-id="element-5880">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6" data-id="element-5881">
            <Mail className="w-8 h-8 text-primary" data-id="element-5882" />
          </div>

          <h1 className="text-2xl font-bold text-textMain mb-3" data-id="element-5883">
            Check your email
          </h1>
          <p className="text-textMuted text-sm mb-8 leading-relaxed" data-id="element-5884">
            We sent a verification link to{' '}
            <span className="font-medium text-textMain" data-id="element-5885">mark@example.com</span>.
            Please check your inbox and click the link to verify your account.
          </p>

          <div className="space-y-4" data-id="element-5886">
            <button className="w-full py-2.5 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors shadow-[0_0_15px_rgba(245,158,11,0.2)]" data-id="element-5887">
              Resend email
            </button>
            <button className="w-full py-2.5 bg-transparent border border-transparent rounded-lg text-sm font-medium text-textMuted hover:text-textMain hover:bg-background transition-colors" data-id="element-5888">
              Change email
            </button>
          </div>
        </div>
      </motion.div>
    </div>;
}